module.exports = __webpack_public_path__ + "media/categories/4027-356f1596.svg";